<template>
  <o-dialog
    ref="dialog"
    :title="$t('reservation.checkInCustomer')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('reservation.confirmCheckIn'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  >
    <div v-if="reservation && !hasSale" class="pt-4 text-left space-y-4">
      <template v-for="(service, index) in services" :key="index">
        <div v-if="options.services[index].customerPasses.length">
          <div>
            <p class="opacity-90 text-sm" leading-none>
              {{ service.service.title }}
            </p>
            <p class="opacity-70 text-xs leading-none mb-1">
              {{ service.employee.displayName }}
            </p>
          </div>

          <discount-select
            v-if="options.services[index].customerPasses"
            :service="service"
            :employee="service.employee"
            v-model:customerPass="service.customerPass"
            :customerPasses="options.services[index].customerPasses"
            :placeholder="$t('pass.select')"
            class="w-full"
          />
        </div>
      </template>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import DiscountSelect from '@/components/reservation/elements/DiscountSelect.vue'

interface Props {
  reservation?: Record<string, any> | null
  portal?: string | null
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  reservation: null,
  portal: null,
  loading: false,
})

const emit = defineEmits<{
  'update:loading': [value: boolean]
  'update:reservation': [value: any]
}>()

const { $api, $notification, $bus, $i18n } = useNuxtApp()

const dialog = ref<any>(null)

const services = ref<any[]>([])

const info = computed(() => {
  return $i18n.t('components.reservation.actions.checkIn.info', { name: props.reservation?.customer.displayName, label: props.reservation?.customerInfoLabel })
})

const options = computed(() => {
  return props.reservation?.options
})

const hasSale = computed(() => {
  return !!props.reservation?.order
})

function open() {
  dialog.value.open()

  services.value = props.reservation!.services
    .map((service: any) => toRaw(service).clone())
}

async function confirm() {
  emit('update:loading', true)

  const findPass = 0
  const servicesVal = services.value

  const customerPasses = servicesVal
    .map((service: any) => service.customerPass?.idCustomerPass)

  try {
    const reservationId = props.reservation?.idReservation?.toString()
    const response = await $api.reservation.checkIn(reservationId, { findPass: !!findPass, customerPasses })
    const reservation = response.data

    if (reservation) {
      emit('update:reservation', reservation)
      emit('update:loading', false)

      $bus.emit.updated('Reservation', reservation)

      $notification.toast({
        title: $i18n.t('reservation.checkedIn'),
        text: $i18n.t('components.reservation.actions.checkIn.successInfo', { name: props.reservation!.customer.displayName }),
        variant: 'success',
      })

      emit('update:loading', false)

      return true
    }
  } catch (e: any) {
    console.log(e)

    $notification.error({ errors: e?.errors })

    emit('update:loading', false)

    return true
  }
}

defineExpose({ open })
</script>
